const HOUR_MS = 60 * 60 * 1000

/**
 * "Now" for use as a query variable, rounded down to the hour.
 *
 * The server cache in server/utils/data-cache.ts keys on a hash of the variables,
 * so a millisecond timestamp made every request a cache miss *and* wrote a fresh
 * entry per request. An hour is close enough for `visibleUntil` / upcoming filters
 * and bounds the key space to 24 per query per day.
 */
export const cacheableNow = () => new Date(Math.floor(Date.now() / HOUR_MS) * HOUR_MS).toISOString()
